export const acquired = {
  inHouse: "Internal",
  externally: "External",
  IHA: "INT",
  POA: "EXT",
  PIHAw: "EXT-w",
  IHAw: "INT-w",
  unknown: "Not Set"
};
